import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { ThemeProvider } from './app/theme/ThemeProvider';
import Paperbase from './app/components/PaperBase';
import Footer from './app/components/Footer';
import { Analytics } from './app/components/Analytics';
import './styles/global.css';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <Router>
          <div className="app-container">
            <Analytics />
            <Paperbase />
            <Footer />
          </div>
        </Router>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;